<template>
  <div>
    <el-table
      ref="elTable"
      v-if="!$isMobile()"
      :data="tableData"
      @header-click="clickHeader"
      highlight-current-row
      @current-change="handleCurrentChange"
      @cell-click="handleClick"
      @row-dblclick="handleDblClick"
      :cell-class-name="tableCellClassName"
      @row-click="rowClick"
      style="width: 100%"
      v-on="$listeners"
      v-bind="$attrs"
      :class="className"
      @selection-change="handleSelectionChange"
      :empty-text="$t('messages.lblEmptyText')"
    >
      <!-- :row-class-name="rowClass" disable 사용하실때 사용하면 됩니다. -->
      <template v-for="(item, index) in tableHeader">
        <template v-if="item.mergeType === 'headerGroup'">
          <el-table-column
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :type="item.type"
            :align="item.align"
            :min-width="item.width"
            :selectable="selectable"
          >
            <template v-for="(childrenItem, childrenIndex) in item.children">
              <el-table-column
                v-if="childrenItem.columnType === 'custom'"
                :prop="childrenItem.prop"
                :label="childrenItem.label"
                :min-width="childrenItem.width"
                :key="childrenIndex"
                :selectable="selectable"
              >
                <template slot-scope="scope">
                  <slot :name="childrenItem.prop" v-bind:scope="scope"></slot>
                </template>
              </el-table-column>
              <el-table-column
                v-else
                :key="childrenIndex"
                :prop="childrenItem.prop"
                :label="childrenItem.label"
                :min-width="childrenItem.width"
                :type="childrenIndex.type"
                :selectable="selectable"
              />
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            v-if="item.columnType === 'custom'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
            :type="item.type"
            :align="item.align"
            :selectable="selectable"
          >
            <template slot-scope="scope">
              <slot :name="item.prop" v-bind:scope="scope"></slot>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
            :type="item.type"
            :align="item.align"
            :selectable="selectable"
          />
        </template>
      </template>
    </el-table>
    <div v-else>
      <ul>
        <li
          class="ly-list-box"
          v-for="(items, idx) in tableData"
          :style="items.colorData"
          :key="idx"
          @click="liClick(items)"
        >
          <div class="list-box" @click="activeItem(idx)"
          :ref="'list' + idx">
            <el-button type="notepad" v-if="notepad" @click="isOpition(items)"
              ><i class="icon-Notepad"
            /></el-button>
            <ul v-if="tableType == 'btnTitle'" class="ntf-list">
              <!--
              <li :key="items.col1" class="list-box-content state">
                <template v-for="subItem in items.state">
                  <el-tag size="mini" :key="subItem" :type="stateTxt(subItem)">
                    {{ subItem }}
                  </el-tag>
                </template>
              </li>
              -->
              <template v-for="(item, index) in tableHeader" >
                <template v-if="item.prop == 'notiGb'">
                  <span :key="index" class='title-type'>
                    <template v-if="item.columnType === 'custom'" class="">
                      <slot
                        :name="item.prop"
                        v-bind:scope="{ row: items, $index: idx }"
                      ></slot>
                    </template>
                  </span>
                </template>
                <template v-else-if="item.prop == 'title'">
                  <span class="list-box-title" :key="index">
                    {{ items[item.prop] }}
                  </span>
                </template>
                <template v-else-if="item.prop !== 'title' && item.prop !== 'notiGb'">
                  <li
                    :key="index"
                    class="list-box-content"
                    :class="{ title: item.prop === 'title' } && item.classType"
                    v-if="
                      item.prop !== 'rn' &&
                      item.type !== 'index' &&
                      item.type !== 'selection'
                    "
                  >
                    <span class="title" v-if="item.prop !== 'title'">
                      {{ item.label }}
                    </span>
                    <div class="content">
                      <!--<template v-if="item.type === 'selection'">
                        <el-checkbox v-model="item.prop"></el-checkbox>
                      </template>-->

                      <template v-if="item.columnType === 'custom'">
                        <slot
                          :name="item.prop"
                          v-bind:scope="{ row: items, $index: idx }"
                        ></slot>
                      </template>
                      <span v-else>{{ items[item.prop] }}</span>
                    </div>
                  </li>
                </template>
              </template>
            </ul>
            <ul v-else>
              <!--
              <li :key="items.col1" class="list-box-content state">
                <template v-for="subItem in items.state">
                  <el-tag size="mini" :key="subItem" :type="stateTxt(subItem)">
                    {{ subItem }}
                  </el-tag>
                </template>
              </li>
              -->
              <template v-for="(item, index) in tableHeader" >
                <template v-if="item.prop !== 'title'">
                  <li
                    :key="index"
                    class="list-box-content"
                    :class="{ title: item.prop === 'title' } && item.classType"
                    v-if="
                      item.prop !== 'rn' &&
                      item.type !== 'index' &&
                      item.type !== 'selection'
                    "
                  >
                    <span class="title" v-if="item.prop !== 'title'">
                      {{ item.label }}
                    </span>
                    <div class="content">
                      <!--<template v-if="item.type === 'selection'">
                        <el-checkbox v-model="item.prop"></el-checkbox>
                      </template>-->

                      <template v-if="item.columnType === 'custom'">
                        <slot
                          :name="item.prop"
                          v-bind:scope="{ row: items, $index: idx }"
                        ></slot>
                      </template>
                      <span v-else>{{ items[item.prop] }}</span>
                    </div>
                  </li>
                </template>
              </template>
            </ul>
            <div class="btn-delect" v-if="isDeleted">
              {{ $t("messages.btnDelete") }}
              <el-button type="minus" size="small" @click="isDelete()"
                ><i class="icon-Minus"
              /></el-button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableHeader: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    className: {
      type: String,
      default: "",
    },
    notepad: {
      type: Boolean,
      default: false,
    },
    isDeleted: {
      type: Boolean,
      default: false,
    },
    tableType: {
      type: String,
      default: ''
    },
    listClick: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentRow: 0,
      currentCell: 0,
      clickRow: 0,
      oldCell: null,
      borderStyle: "border: 1px solid #CDDAEF",
      popTableData: [],
      prevOn: '',
    };
  },
  mounted(){
  },
  methods: {
    selectable(row) {
      if (row.selectable != null) {
        if (row.selectable == false) {
          return false; // Not Optional
        } else {
          return true; // Optional
        }
      } else {
        return true; // default
      }
    },
    handleSelectionChange(rowData) {
      this.popTableData = rowData;
      this.$emit("selectionCheckRow", this.popTableData);
      this.popTableData = [];
    },
    clickHeader(e) {
      e.sortable = e.sortable ? false : true;
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange(crt) {
      this.currentRow = crt;
    },
    // disabled 입니다.
    // rowClass({ rowIndex }) {
    //   if (rowIndex === 1) {
    //     return "is-disabled";
    //   }
    // },
    tableCellClassName(rowIndex, columnIndex) {
      if (rowIndex === this.currentRow && columnIndex === this.currentCell) {
        return "active";
      }
    },
    handleClick(row, column, cell) {
      if (this.clickRow === row.col1) {
        if (this.oldCell) {
          this.oldCell.style = "";
        }
        cell.style = this.borderStyle;

        this.oldCell = cell;
        this.currentRow = row;
        this.currentCell = column;
      }
    },
    handleDblClick(row, col) {
      this.$emit("rowDblClick", row);
    },
    rowClick(row, col) {
      this.clickRow = row.col1;
      this.$EventBus.$emit("rowClick", row, col);
      this.$emit("clickRow", col, row);
    },
    liClick(items) {
      this.$EventBus.$emit("rowClick", items, items);
      this.$emit("clickRow", items, items);
    },
    activeItem(e){
      if(this.listClick == 'border'){
        if(this.prevOn !== ''){
          this.$refs['list'+this.prevOn][0].style = '';
        }
        this.$refs['list'+e][0].style = "border: 1px solid #24c4dc"
        this.prevOn = e;
      } 
      if(this.listClick == 'carBorder'){
        let borderColor = "";
        if(this.$refs['list'+e][0].style.borderColor.length == 0) {
          borderColor = "border: 1px solid #24c4dc"
        }
        this.$refs['list'+e][0].style = borderColor;
      }
    },
    isOpition(data) {
      this.$EventBus.$emit("isOpition", data.apvOpin);
    },
    isDelete() {
      this.$EventBus.$emit("isDelete");
    },
    stateTxt(txt) {
      let result = "";
      switch (txt) {
        case "신규 요청":
        case "요청":
        case "승인 완료":
          result = "request";
          break;
        case "처리중":
          result = "point";
          break;
        case "사용중":
        case "대여":
          result = "in-use";
          break;
        case "입고":
        case "승인":
          result = "primary";
          break;
        case "반려":
        case "연체":
        case "파손":
          result = "reject";
          break;
        case "대기":
        case "보류":
          result = "wait";
          break;
        case "완료":
        case "반납":
          result = "info";
          break;
      }
      return result;
    },
  },
};
</script>
<style lang="scss">
.el-table {
  // 2022.03.25 스크롤 수정
  &__body-wrapper {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      &-thumb {
        width: 3px;
        height: 3px;
        background-color: $--text-disabled;
        border-radius: $--border-radius-base;
      }
    }
  }
  .el-table__cell {
    padding: 10px 0;
    font-size: $--font-size-base;
    line-height: 20px;
    &.is-sortable {
      padding: 0;
      .cell {
        padding: 0;
      }
    }
  }
  .cell {
    line-height: 20px;
    // white-space: nowrap;
    gap: 5px;
    .el-checkbox__input {
      vertical-align: top;
    }
  }
  .is-disabled {
    background-color: $--table-row-disabled-background-color;
    color: $--table-row-disabled-font-color;
    &:hover > td.el-table__cell {
      background-color: $--table-row-disabled-background-color !important;
      color: $--table-row-disabled-font-color;
    }
  }
  &__body tr.current-row > td.el-table__cell {
    color: $--color-primary;
    font-weight: $--font-weight-Medium;
  }
  .el-input__inner {
    padding: 3px;
    font-size: $--font-size-table-small;
  }
  thead.is-group {
    tr {
      &:not(:first-child) {
        th.el-table__cell {
          border-top: 1px solid $--color-light-gray;
        }
      }
    }
    th.el-table__cell {
      border: 0;
      background: $--color-white-smoke;
    }
  }
  &--border .el-table__cell {
    border-right: 0;
  }
  &.list {
    .el-table__body {
      border-spacing: 0 15px;
    }
    .cell {
      display: block;
    }
    th.el-table__cell {
      background: $--color-white-smoke;
      border: {
        top: 1px solid $--list-border-color;
        bottom: 1px solid $--list-border-color;
      }
      &:first-child {
        border: {
          left: 1px solid $--list-border-color;
          radius: 8px 0 0 8px;
        }
      }
      &:nth-last-child(2) {
        border: {
          right: 1px solid $--list-border-color;
          radius: 0 8px 8px 0;
        }
      }
    }
    td.el-table__cell {
      border: {
        top: 1px solid $--input-line-default;
        bottom: 1px solid $--input-line-default;
      }
      &:first-child {
        border: {
          left: 1px solid $--input-line-default;
          radius: 8px 0 0 8px;
        }
      }
      &:last-child {
        border: {
          right: 1px solid $--input-line-default;
          radius: 0 8px 8px 0;
        }
      }
    }
  }
}
.ly-list-box {
  .list-box {
    position: relative;
    text-align: left;
    padding: 13px;
    margin-bottom: 10px;
    .ntf-list{
      .list-box-content{
        .title{
          width: 50px;
        }
      }
    }
    font: {
      size: $--font-size-base;
      weight: $--font-weight-default;
    }
    border: 1px solid $--border-color-gray {
      radius: $--border-radius-base;
    }
    &-title{
      display:inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 60px);
      font-size: $--font-size-medium;
      margin-bottom: -6px;
    }
    .title-type{
      margin-right: 8px
    }
    &-content {
      display: inline-block;
      width: calc(50% - 5px);
      vertical-align: top;
      padding-top: 10px;
      text-align: left;
      &.title {
        width: 100%;
        .content {
          margin-left: 0;
          width: 100%;
          font: {
            size: $--font-size-base;
            weight: $--font-weight-bold;
          }
          color: $--color-black;
        }
      }
      &.state {
        display: block;
        & + .list-box-content {
          padding-top: 10px;
        }
      }
      &.is-mob-disable {
        display: none;
      }
      .el-tag + .el-tag {
        margin-left: 5px;
      }
      &:nth-child(2n) {
        margin-left: 10px;
      }
      &:first-child {
        padding: 0;
      }
      &:nth-child(2) {
        padding: 0;
      }

      &.is-mob-full {
        width: 100%;
        margin-left: 0;
        & + .list-box-content {
          margin-left: 0;
        }
      }
      .title {
        display: inline-block;
        width: 70px;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: $--text-nodata;
        letter-spacing: -1px;
      }
      .content {
        display: inline-block;
        width: calc(100% - 75px);
        margin-left: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: $--color-black;
        letter-spacing: -1px;
      }
    }
    .el-button--notepad {
      position: absolute;
      top: 13px;
      right: 13px;
    }
  }
}
</style>
